import React, { useState, useEffect } from 'react';
import OTPField from '../../../../IBANGeneratorComponent/OTPField/index';
import Logo from '../../../../../assets/images/LogoBlu.svg';
import './style.scss';
import { Dialog, DialogContent, DialogTitle, Box } from '@mui/material';
import sendIcon from '../../../../../assets/images/sendIcon.svg';
import Button from '../../../../Shared/components/controls/Button/index';
import Loader from '../../../../IBANGeneratorComponent/Loader/index';
import config from '../../../../../Config.js';
import { withTranslation } from 'react-i18next';
import { useSitecoreContext, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ReCAPTCHA from 'react-google-recaptcha';
import clsx from 'clsx';
import { getCSRFToken, refreshCSRFTokenIfNeeded, clearCSRFToken } from '../../../../../utils/csrf';

const TravelStepTwo = ({
  setActiveStep,
  trips,
  EditDatesFormEndpoint,
  generateOTPResponse,
  IsMockVerifyOTPEndpoint,
  VerifyOTPEndpoint,
  extraUserData,
  verifyOTPResponse,
  setVerifyOTPResponse,
  setGenerateOTPResponse,
  GenerateOTPEndpoint,
  GenerateOTPToken,
  IsMockGenerateOTPEndpoint,
  t,
  isDeleted,
  setIsDeleted,
  limitationNumber,
  limitationMessage,
  timeoutErrorMessage,
  verificationCodeExpiredErrorMessage,
  timeout,
  otpVerificationCode,
  otpDidNotReceiveText,
  otpSendNewCodeText
}) => {
  const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
  const [isFormValid, setIsFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState();
  const [verifyOTPResponseError, setVerifyOTPResponseError] = useState();
  const [error, setError] = useState([
    { status: false, msg: '' },
    { status: false, msg: '' },
  ]);
  const context = useSitecoreContext();
  const showRecaptcha = true;
  let recaptchaKey = context?.sitecoreContext?.siteConfigurations?.googleReCAPTCHAKey;
  let shouldRenderRecaptcha = showRecaptcha && recaptchaKey !== '' && !loading;
  const [openDialog, setOpenDialog] = useState(false);
  const LOCAL_STORAGE_ATTEMPT_KEY = 'otpAttemptsStep_EditTravelDatesRequest';
  const LOCAL_STORAGE_DISABLE_OTP_KEY = 'disableGenerateOtpButton_EditTravelDatesRequest';
  const LOCAL_STORAGE_OTP_TIMER_KEY = 'otpDateCanGenerate_EditTravelDatesRequest';
  const [forceDisableMessage, setForceDisableMessage] = useState('');
  const [forceDisable, setForceDisable] = useState(false);
  const [output, setOutput] = useState('--:--');
  const [userCanSendState, setUserCanSendState] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [newCode, setNewCode] = useState(0);

  const onRecaptchachange = (value) => {
    setRecaptchaValue(value === null ? null : value);
  };
  
  useEffect(() => {
    const isValid = otpValue.join('').length === 6 && recaptchaValue != null;
    setIsFormValid(isValid);
  }, [otpValue, recaptchaValue]);

  const showError = (message, disableBtn = true) => {
    setForceDisable(disableBtn);
    setForceDisableMessage(message);
  };

  const changeNumberToTwoDigits = (num) =>
    num.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  
  const hiddeError = () => {
    setForceDisable(false);
    setForceDisableMessage('');
  };
  
  const userCanSend = () => {
    if (typeof localStorage !== 'undefined') {
      const disableGenerateOtpButtonValue = localStorage.getItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
      let disabledUntil = new Date(disableGenerateOtpButtonValue);
      
      if (!!disableGenerateOtpButtonValue) {
        if (new Date() <= disabledUntil) {
          showError(`${limitationMessage}`);
          setUserCanSendState(false);
          return false;
        } else {
          localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
          setAttemptsStorage(limitationNumber);
          hiddeError();
          setUserCanSendState(true);
          return true;
        }
      } else {
        setUserCanSendState(true);
        return true;
      }
    }
    setUserCanSendState(false);
    return false;
  };

  const getAttemptsStorage = () => {
    if (typeof localStorage !== 'undefined') {
      const attempts = parseInt(
        localStorage.getItem(LOCAL_STORAGE_ATTEMPT_KEY) || limitationNumber
      );
      return attempts;
    }
  };
  
  const setAttemptsStorage = (attempts) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_ATTEMPT_KEY, attempts);
    }
  };
  
  const decrementAttemptsStorage = (dateBlockUntil, numberofRemainingRetries) => {
    if (typeof localStorage !== 'undefined') {
      let attempt = getAttemptsStorage();
      const newAttemptStorage =
        typeof numberofRemainingRetries !== 'undefined' && numberofRemainingRetries !== attempt - 1
          ? numberofRemainingRetries
          : attempt - 1;
      if (newAttemptStorage === -1) {
        showError(`${limitationMessage}`);
        if (!!dateBlockUntil) {
          localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, dateBlockUntil);
        }

        if (new Date() >= dateBlockUntil) {
          setAttemptsStorage(limitationNumber);
          localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
          hiddeError();
        }
      } else {
        setAttemptsStorage(newAttemptStorage);
      }
    }
  };
  
  useEffect(() => {
    setBtnDisabled(false);
    let elapsedTime = timeout || 0;
    const x = setInterval(() => {
      const dueDate = new Date();
      dueDate.setSeconds(dueDate.getSeconds() + elapsedTime);
      const now = new Date().getTime();
      const distance = dueDate.getTime() - now;
      if (distance < 0) {
        clearInterval(x);
        setBtnDisabled(true);
        return;
      }
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setOutput(`${changeNumberToTwoDigits(minutes)}:${changeNumberToTwoDigits(seconds)}`);
      elapsedTime--;
    }, 1000);
    return () => {
      clearInterval(x);
    };
  }, [newCode]);
  
  // Send new Otp code
  const sendNewCode = async () => {
    try {
      if (userCanSend()) {
        const generateSMS = await GenerateOTP(extraUserData.Data.CustomerNo);
        let dateBlockUntil = null;
        const attempts = getAttemptsStorage();

        if (
          attempts === 0 ||
          generateSMS?.output?.numberofRemainingRetries === 0 ||
          generateSMS?.output?.errorCode === 'LimitReached'
        ) {
          if (generateSMS?.output?.success !== '1') {
            if (attempts === 0) {
              showError(generateSMS?.output?.errorMessage, false);
            } else {
              showError(generateSMS?.output?.errorMessage);
            }
          }

          dateBlockUntil = new Date();
          dateBlockUntil.setMinutes(
            dateBlockUntil.getMinutes() + generateSMS?.output?.oTPLimitResetDurationInMinutes
          );

          localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, dateBlockUntil);
        }
        if (generateSMS?.output?.errorCode !== 'TimeElapsed') {
          decrementAttemptsStorage(
            dateBlockUntil,
            generateSMS?.output?.numberofRemainingRetries
          );
        } else {
          if (generateSMS?.output?.success !== '1') {
            const OTPDateBlockUntil = localStorage.getItem(LOCAL_STORAGE_OTP_TIMER_KEY);
            const OTPDateBlockUntilDate = new Date(OTPDateBlockUntil);
            const diffInSeconds = Math.ceil(
              Math.abs(new Date().getTime() - OTPDateBlockUntilDate.getTime())
            );
            console.log('diffInSeconds', diffInSeconds);
          }
        }
        setAttempts(0);
        setNewCode((prev) => ++prev);
        setError((prev) => {
          prev[1].status = false;
          prev[1].msg = '';
          return prev;
        });
        setRecaptchaValue(null);
        setOtpValue(['', '', '', '', '', '']);
        if (typeof window !== 'undefined' && window?.grecaptcha?.reset) {
          window.grecaptcha.reset();
        }
      }
    } catch (err) {
      console.log('Error in generating a new OTP', err);
      setRecaptchaValue(null);
    }
  };

  const GenerateOTP = async (customerNo) => {
    try {
      const url = `${config.hostname}${GenerateOTPEndpoint}?mock=${IsMockGenerateOTPEndpoint}&reference=${customerNo}&token=${GenerateOTPToken}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Failed to generate OTP');
      }

      const data = await response.json();
      setGenerateOTPResponse(data); 
      return data;
    } catch (error) {
      setRecaptchaValue(null);
      throw error;
    }
  };

  const verifyOTP = async () => {
    if (generateOTPResponse && generateOTPResponse.output.success === '1') {
      try {
        const url = `${config.hostname}${VerifyOTPEndpoint}`;
        const requestBody = {
          mock: IsMockVerifyOTPEndpoint,
          reference: IsMockVerifyOTPEndpoint === "1" ? "abc987" : extraUserData.Data.CustomerNo,
          recaptchaToken: recaptchaValue,
          otp: IsMockVerifyOTPEndpoint === "1" ? "987654" : otpValue.join('')
        };
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json(); 
        if(data?.output?.verified === "1"){
          setVerifyOTPResponse(data);
          return data;
        } else {
          setVerifyOTPResponseError(t('invalidOTPErrorMessage')); 
          return null;
        }
      } catch (error) {
        setVerifyOTPResponseError(error.message);
        setRecaptchaValue(null);
        throw error; 
      }
    }
    throw new Error('OTP generation not successful'); 
  };

  const callEditFormEndpoint = async () => {
    const requestBody = {
      Trips: trips?.map((trip) => ({
        TripID: trip.id,
        Country: trip.destination,
        Outbound: trip.isEdited ? new Date(trip.outboundDate).toISOString() : trip.outboundDate,
        Inbound: trip.isEdited ? new Date(trip.inboundDate).toISOString() : trip.inboundDate,
        isDeleted: isDeleted[trip.id] || false,
      })),
    };

    try {
      // Get the API host
      const apiHost = config.sitecoreApiHost || config.hostname || window.location.origin;
      
      // Ensure we have a valid CSRF token
      await refreshCSRFTokenIfNeeded(apiHost);
      const csrfToken = getCSRFToken();

      if (!csrfToken) {
        throw new Error('CSRF token not available. Please refresh the page and try again.');
      }

      const url = `${apiHost}${EditDatesFormEndpoint}`;
      
      const response = await fetch(url, {
        method: 'PUT',
        credentials: 'include', // Important for cookies
        headers: {
          'Content-Type': 'application/json',
          '__RequestVerificationToken': csrfToken,
        },
        body: JSON.stringify(requestBody),
      });

      // Handle CSRF token validation failure
      if (response.status === 403) {
        console.warn('CSRF validation failed. Clearing token...');
        clearCSRFToken();
        throw new Error('Security validation failed. Please refresh the page and try again.');
      }

      if (response.status === 401) {
        throw new Error('Authentication required. Please refresh the page and try again.');
      }

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error during submission:', error);
      setRecaptchaValue(null);
      
      // Show user-friendly error message
      if (error.message.includes('CSRF') || error.message.includes('Security')) {
        setVerifyOTPResponseError(t('SecurityErrorMsg') || 'Security validation failed. Please refresh the page.');
      } else if (error.message.includes('Authentication')) {
        setVerifyOTPResponseError(t('AuthenticationErrorMsg') || 'Authentication required. Please refresh the page.');
      } else {
        setVerifyOTPResponseError(t('GenericErrorMsg') || 'An error occurred. Please try again.');
      }
      
      return null;
    }
  };

  const submitEditDatesFormHandler = async () => {
    try {
      setLoading(true);
      setVerifyOTPResponseError(''); // Clear previous errors
      
      var verificationResult = await verifyOTP(); 
      console.log(verificationResult);
      
      // Check the verification result
      if (verificationResult && verificationResult.output.verified === '1') {
        const result = await callEditFormEndpoint();
        if (result && result.StatusCode === 200) {
          setLoading(false);
          setActiveStep(3);
        } else {
          console.log(result?.Message || 'Edit form submission failed');
          setVerifyOTPResponseError(result?.Message || t('GenericErrorMsg'));
          setLoading(false);
        }
      } else {
        console.error('OTP verification failed');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error during OTP verification:', error);
      setRecaptchaValue(null);
      setLoading(false);
    }
  };

  function maskPhoneNumber(phoneNumber) {
    if (phoneNumber.length < 6) {
      return phoneNumber;
    }
    return phoneNumber.slice(0, 4) + '******' + phoneNumber.slice(-2);
  }

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="TravelTwoContainer">
      {/* subheader */}
      <div className="subHeader">
        <div className="startedContainer">
          <span>{t('Letsgetstarted')}</span>
        </div>
        <div className="welcomeContainer">
          <span>{t('welcomeContainer')}</span>
        </div>
        <div className="descContainer">
          <span>{t('descContainer')}</span>
        </div>
      </div>
      
      {/* verify card */}
      <div className="verifyCard">
        {/* header */}
        <div className="verifyHeaderContainer">
          <span className="verifyHeader">{t('verifyHeaderContainer')}</span>
          <span className="verifySubHeader">{t('verifySubHeader')} </span>
        </div>
        <div className="phonenumber">
          <span>
            {t('phonenumbertext')} <span className='directionClass'>{maskPhoneNumber(extraUserData.Data.PhoneNumber)}</span>{' '}
          </span>
        </div>
        <div className="otp">
          <OTPField
            value={otpValue}
            setValue={setOtpValue}
            setOtpValue={(val) => console.log('OTP Value:', val)}
            error={error[1].status}
            setError={setError}
          />
          {output === '00:00' ? (
            <div className="generic-error">{verificationCodeExpiredErrorMessage}</div>
          ) : null}
          <div className="otp-resend">
            <span className="otp-receive">{otpDidNotReceiveText || ''}</span>
            &nbsp;
            <span
              className={clsx(
                'otp-new-code',
                output !== '00:00' ||
                  (attempts >= limitationNumber - 1 && userCanSendState && !forceDisable)
                  ? 'disabled'
                  : ''
              )}
              onClick={sendNewCode}
            >
              {' '}
              {otpSendNewCodeText || ''} {output !== '00:00' && `(${output})`}
            </span>
          </div>

          {!!forceDisableMessage && forceDisableMessage !== '' && (
            <div className="generic-error">{forceDisableMessage}</div>
          )}
          <div className="generic-error">
            {verifyOTPResponseError}
          </div>
        </div>
      </div>
      
      {shouldRenderRecaptcha && (
        <div className="recaptcha">
          <ReCAPTCHA sitekey={recaptchaKey} onChange={onRecaptchachange} />
        </div>
      )}
      
      {/* buttons */}
      <div className="btnContainer">
        <Button onClick={() => setActiveStep(1)} variant="outlined">
          {t('Previous')}
        </Button>
        <Button onClick={() => submitEditDatesFormHandler()} disabled={!isFormValid}>
          {t('Verify')}
        </Button>
      </div>
      
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '20px',
            maxWidth: '333px',
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 2,
            }}
          >
            <img
              src={sendIcon}
              alt="send-icon"
              style={{
                width: '48px',
                height: '48px',
              }}
            />
            <DialogTitle
              sx={{
                fontWeight: 'bold',
                padding: '10px 0',
              }}
            >
              {t('DialogTitle')}
            </DialogTitle>
            <Box sx={{ color: '#666' }}>{t('DialogTitleDesc')}</Box>
            <Button variant="outlined" onClick={() => setOpenDialog(false)}>
              {t('Done')}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(TravelStepTwo));